/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-07-06 10:24:04
 */
import config from "@/configs/pathConfigures";
import LayoutEx from "@/views/layout/LayoutEx";

export default {
    path: config.prefixUrl,
    component: LayoutEx,
    props: {
        routeMapClass: "route-map__float",
    },
    children: [
        {
            name: "teamManager",
            path: "teams",
            component: () => import("@/views/teamManager/teamManager.vue"),
            meta: {title: "团队管理"}
        }
    ]
}